
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexoa3djZDsm3_45SO6f1PjB4SEYTWAZlPq4IWErztVy_45sKoMeta } from "/vercel/path0/stagedoos/pages/index.vue?macro=true";
import { default as indexbgvkUgrfpp1hz54kuB2NdEwohL3tYf6b2RLjRseCl_45YMeta } from "/vercel/path0/base/pages/content/index.vue?macro=true";
import { default as menu_45itemsbqZ8vse8wlIQvyz2xn9nanWYZq5Z_456t_yXGuKtH0BJcMeta } from "/vercel/path0/base/pages/content/menu-items.vue?macro=true";
import { default as file_45uploadpywHBDu3oeT39VEinTINs4P_45IAnoY1iPbt9sxFYcqicMeta } from "/vercel/path0/base/pages/content/file-upload.vue?macro=true";
import { default as stock_45imagesw_45jl30K9AjVbDBThUIwieGmX2nref96jIRW5pTjyQMMMeta } from "/vercel/path0/base/pages/content/stock-images.vue?macro=true";
import { default as contentGXWpq9tObVjjFJHyj9D9ioI8pM1x9vl6ViUxlnroHdMMeta } from "/vercel/path0/base/pages/content.vue?macro=true";
import { default as _91_91slug_93_93lGwrsvU_45b6ap5SRuJL3wvU7noaDbNO5gWJAhjztdrFgMeta } from "/vercel/path0/stagedoos/pages/[[slug]].vue?macro=true";
import { default as inloggenEMOsHHmKTy8iFnqZcoiDw4uF0TeVte5OIny1GnHO25UMeta } from "/vercel/path0/stagedoos/pages/inloggen.vue?macro=true";
import { default as dashboardj8LJlVmeIxST2H3OVV3rWijiQ3tk2Mce2KJBQ1sDJvsMeta } from "/vercel/path0/stagedoos/pages/dashboard.vue?macro=true";
import { default as authM6xkMaERq0O0C1h9tZiOQcluo_45wwE4pXcHhyjBKq_iQMeta } from "/vercel/path0/base/pages/test/auth.vue?macro=true";
import { default as dupeesfwdPNhguiksYpsbsUNSORkFpYL30oLLcYPc9ZH8uwMeta } from "/vercel/path0/base/pages/test/dupe.vue?macro=true";
import { default as form2Et0Ex1WDnn1LQOzNPPcUaGcF7_45LiF2eHaPWUbkrjwIMeta } from "/vercel/path0/base/pages/test/form.vue?macro=true";
import { default as usergP1j2ugkOOTjfIOTEE84Z4_I0BzGtfGwgtoQkc7whosMeta } from "/vercel/path0/base/pages/test/user.vue?macro=true";
import { default as uitloggenRZCPzRvLi_45FWyxUwAogNzfeERw_JHTQ2DjzbWesid8sMeta } from "/vercel/path0/base/pages/uitloggen.vue?macro=true";
import { default as addtCvDip_45gr_RHXHHnVup4604_45OGSrQgt9rSwO0VvjptcMeta } from "/vercel/path0/base/pages/users/add.vue?macro=true";
import { default as reset78Ka2XQeSD_Mqmo_45L0NKLVjPtxjgEJykMea_cq2GcswMeta } from "/vercel/path0/base/pages/auth/reset.vue?macro=true";
import { default as tokenNvAQPDX2cOrVU3WRWm_45UAU_45Tqvl6M9XYQ3YtXd_hh2QMeta } from "/vercel/path0/base/pages/auth/token.vue?macro=true";
import { default as adddUW9h28Wl_8bY7GPvt8jR1LajT_fxmA5mBm0AQJRI3IMeta } from "/vercel/path0/stagedoos/pages/groups/add.vue?macro=true";
import { default as colorsCnrXXnlfUQs9MGmkYVaPZ7oKt3LHVe9RpSN87tAw3bwMeta } from "/vercel/path0/base/pages/test/colors.vue?macro=true";
import { default as sentryfO_83x5yZMymiL_45F6SQoM_45_0iDolX_45zg7eJwJDy6leYMeta } from "/vercel/path0/base/pages/test/sentry.vue?macro=true";
import { default as indexFukoIn_459388Jem9pfucq_457ZATztFhwjpo17oQaef_45ToMeta } from "/vercel/path0/base/pages/users/index.vue?macro=true";
import { default as login_451OezAPgOU8OgIsqyIsj0rIcnrmiegfAWEU7y5OhX0Xy4Meta } from "/vercel/path0/base/pages/auth/login-1.vue?macro=true";
import { default as recoverKAswSXY0F54QD5SJTFd1JgQTo9zF7PIqylCuE7vRqdoMeta } from "/vercel/path0/base/pages/auth/recover.vue?macro=true";
import { default as indexQl69768KPm15sXtsSdPFEaw_456P7805lYMp2zv6i0aukMeta } from "/vercel/path0/stagedoos/pages/groups/index.vue?macro=true";
import { default as emailMKp8r5narSwuEcSJPdhrqpdj8ZVg7l6jcPE31YNhzKUMeta } from "/vercel/path0/stagedoos/pages/profile-edit/email.vue?macro=true";
import { default as indexIue_45s_DLditFyw_WV5GqVR3b7wdCO9MveCIzg_45P76egMeta } from "/vercel/path0/base/pages/profile-edit/index.vue?macro=true";
import { default as settings9KYisyRo2PMIyO3Jp18T_45xk0BRll6i8KO0JK1In1g_45sMeta } from "/vercel/path0/base/pages/profile-edit/settings.vue?macro=true";
import { default as periodieke_45maild6nSl4UYxMtQDEubXVQAyDUkngVcNc3xSrLrydPtKq0Meta } from "/vercel/path0/base/pages/profile-edit/periodieke-mail.vue?macro=true";
import { default as profile_45editfJHqxD9pjopzAWMddQFTUyFlSqGdMh9SStSTdLx5xFsMeta } from "/vercel/path0/base/pages/profile-edit.vue?macro=true";
import { default as toasterRFh4AGluamyVxdStjoNnnWCr7HG4iMayusXlEgITz4oMeta } from "/vercel/path0/base/pages/test/toaster.vue?macro=true";
import { default as zelfgevondenQxfCj1kpnkcUeetsbPjy66EnnelYBPBDff2nJMVuReMMeta } from "/vercel/path0/stagedoos/pages/zelfgevonden.vue?macro=true";
import { default as rolesjR_xG6ru98QGFtHOE5uNZyks_4AV1uG7n4jsqkyLh_45EMeta } from "/vercel/path0/base/pages/account/roles.vue?macro=true";
import { default as indexJ542y_0elABrCYz1UPobUSRF8cO5KIJnqcqThFfj9YgMeta } from "/vercel/path0/base/pages/confirm/index.vue?macro=true";
import { default as conversationszGhk6N_45jDHbiMf_456PuGLXVmFVQfVjjxM3Jsp26PCIHkMeta } from "/vercel/path0/stagedoos/pages/conversations.vue?macro=true";
import { default as addOQcGcNcaIL_453qfDeFJb9XhE9Pjbw36ZOtS6HnUaGwUgMeta } from "/vercel/path0/stagedoos/pages/vacancies/add.vue?macro=true";
import { default as recente_actiesPjFeq4NjPpC75d1zb4ahW7m6JUvN_GfT48YN0hRGYocMeta } from "/vercel/path0/stagedoos/pages/recente_acties.vue?macro=true";
import { default as step_45form0sFaJXtv4qVuYIcDrQUKg9D_aXR5Wiqry7UBZ1HMBgMMeta } from "/vercel/path0/base/pages/test/step-form.vue?macro=true";
import { default as index4G1ApQYCnbWmPdCqsKuhBxNOGqXd9GCpl1HjPahe9ucMeta } from "/vercel/path0/base/pages/analytics/index.vue?macro=true";
import { default as _91_91token_93_93G_fI772El8Xn6zqIzr4sJkhuvp_QvgJUfatVtOy9yb4Meta } from "/vercel/path0/base/pages/forms/[[token]].vue?macro=true";
import { default as addLXrvbtGp23ykQYSy7mQscsKJmq8Td_muXLPIwbv9WAkMeta } from "/vercel/path0/stagedoos/pages/mentorships/add.vue?macro=true";
import { default as _91_91slug_93_9347z5XE5NpXFKxdK0utfxGJTDXP3zggcWqBpUSy9VcpwMeta } from "/vercel/path0/base/pages/nieuws/[[slug]].vue?macro=true";
import { default as indexkjcz03WsoTUKrJ_DtxXqmcIbpq8gu45xabRmxVOPekcMeta } from "/vercel/path0/stagedoos/pages/stagebank/index.vue?macro=true";
import { default as datepickerZ9Uc62dayGHTsUBHzNt0voknTbZhe3CWBn9nj9du43MMeta } from "/vercel/path0/base/pages/test/datepicker.vue?macro=true";
import { default as dollar_45apiIa2f9nAr1o32iJ29QvjJwJfHyUrO0_45TKzMVwf72K2SQMeta } from "/vercel/path0/base/pages/test/dollar-api.vue?macro=true";
import { default as user_45store4FnBzCqI24BmXAxOulaUczgQeM3CjoETp4UyHZQxC9sMeta } from "/vercel/path0/base/pages/test/user-store.vue?macro=true";
import { default as editMot6_45mVQAK_jppiwXXjh1s9CkUw0g50YZKmdRJZTy9kMeta } from "/vercel/path0/base/pages/users/[id]/edit.vue?macro=true";
import { default as indexPMhWrKSV1HjnlkAkIKh8TfqSi4CnhcqD4hTnF_45TAYqMMeta } from "/vercel/path0/stagedoos/pages/vacancies/index.vue?macro=true";
import { default as indexpTtRmC9Dty0dqZ96oWkAUDa3p3XSSyjCqxQrej1q6A4Meta } from "/vercel/path0/stagedoos/pages/workflows/index.vue?macro=true";
import { default as contactformulieryD3Wg7Q5zrL5hcuadXrB5u8lnNY_6hxEl4ElQTSolY0Meta } from "/vercel/path0/base/pages/contactformulier.vue?macro=true";
import { default as edit_45fCsoRT_45Y3hJiiBz3dIphY9dyYHmrzHLZhMGb_45fS9fYMeta } from "/vercel/path0/stagedoos/pages/groups/[id]/edit.vue?macro=true";
import { default as formbuilderFB8mzKtmWNnO419Q_x6hZMAeJXMsDD4Q4U4zagmNLF8Meta } from "/vercel/path0/base/pages/test/formbuilder.vue?macro=true";
import { default as step_45form_4526n2AjG9VA3pWcZQqrZyGThp2YaVjfjAzAiU1TqY2XSEMeta } from "/vercel/path0/base/pages/test/step-form-2.vue?macro=true";
import { default as _91id_93SgTGISYKi9TTreLm1yfSZW_osgKfkYDHDTxfDRoWj9UMeta } from "/vercel/path0/stagedoos/pages/urenbriefje/[id].vue?macro=true";
import { default as indexT_slu_RCDKnUixR51nzwuouyGgy_vK8OWtFFllsBlssMeta } from "/vercel/path0/base/pages/users/[id]/index.vue?macro=true";
import { default as index_452Nt_45xlu3NU_45YYWUoHxdcuG29Wwtj0eHymtB6oHzq30aMMeta } from "/vercel/path0/base/pages/analytics/index-2.vue?macro=true";
import { default as index_45tF6nX0InR28zIHyi2tgJEZdM5u7ekqW_45E_45fGwlGGtMMeta } from "/vercel/path0/stagedoos/pages/groups/[id]/index.vue?macro=true";
import { default as indexSRPcCpabJtCVwr6aSIvFXCllZ0syhXQcIQaO8Py4Yd0Meta } from "/vercel/path0/stagedoos/pages/internships/index.vue?macro=true";
import { default as indexN1NziQ3dmMm1gHOgfSQ_45qLZmb8AA1DI7RoNA_Yz8YPkMeta } from "/vercel/path0/stagedoos/pages/mentorships/index.vue?macro=true";
import { default as addEwnilRuDqhJH6NRxPPTiIoUKldGP25X7A7MAjlZLSi0Meta } from "/vercel/path0/stagedoos/pages/organizations/add.vue?macro=true";
import { default as privacyverklaringwYxZA0bIjS_45HoZZPYeaENr9k70AVtdd8KqHgWjQclRAMeta } from "/vercel/path0/stagedoos/pages/privacyverklaring.vue?macro=true";
import { default as server_45errorCK7Dj7WFlafDQZYt4eOA0yJozYbX1b0D89CMmgFmwrQMeta } from "/vercel/path0/base/pages/test/server-error.vue?macro=true";
import { default as indexBbFErP6sjWbRS_IXqDtJKNzrnOxMcfpXNQJ6oU1xr_QMeta } from "/vercel/path0/stagedoos/pages/instellingen/index.vue?macro=true";
import { default as assigndP9HrjZRJ7_45DFsK0IZAPhKMWby5I0FzR13HuAFo2O_45QMeta } from "/vercel/path0/stagedoos/pages/internships/assign.vue?macro=true";
import { default as indexcB3aCEMLIlH7_45SklrjPvOEqadJKIKxCMAMaHQFdFDS0Meta } from "/vercel/path0/base/pages/notificaties/index.vue?macro=true";
import { default as edit47xhWm_q69GRD0TtYCFMXNlVcbZkesclMuqrb9icingMeta } from "/vercel/path0/stagedoos/pages/students/[id]/edit.vue?macro=true";
import { default as indexYHOhRXYP4gWXdgC04g3qCjcd_5aDuSn_gz_45nx3EviwEMeta } from "/vercel/path0/stagedoos/pages/import_groups/index.vue?macro=true";
import { default as indexWHrP4fwQiHeqYq_dJxmhGI7tK9Bf7Edhp7WVp26pytgMeta } from "/vercel/path0/stagedoos/pages/organizations/index.vue?macro=true";
import { default as add_roleuzkNVv8IQYd2C1r_45rqzdpaB2jJln_OKQJ9EuIh0HFqUMeta } from "/vercel/path0/base/pages/users/[id]/add_role.vue?macro=true";
import { default as editdeikad3i13qIYF1fgQTrukSv75CK5RwAthY26V48OkQMeta } from "/vercel/path0/stagedoos/pages/vacancies/[id]/edit.vue?macro=true";
import { default as indexWJrRNuIYBjjtp6kLpT_Uspw46ohRDk_45j1e0MKdy3EZYMeta } from "/vercel/path0/stagedoos/pages/contracts/[id]/index.vue?macro=true";
import { default as indexapQX24oN9avRxa8nV2WOAi5PQSVjfD6bNvQBMqfrfjkMeta } from "/vercel/path0/stagedoos/pages/stagevoortgang/index.vue?macro=true";
import { default as indexhAztVC_SaeBkvwaTGsmYw58H9ppaTtzV_Hub_45i9rWcUMeta } from "/vercel/path0/stagedoos/pages/vacancies/[id]/index.vue?macro=true";
import { default as indexuigmWGSxpsEz2JcwXnimlmcxfCnXgONVpB3w8vJdaiMMeta } from "/vercel/path0/stagedoos/pages/workflows/[id]/index.vue?macro=true";
import { default as editCJZgE8NX5yj_45dHR32QYrQy1_T2iAgzdvXDmWZn2wiQUMeta } from "/vercel/path0/stagedoos/pages/internships/[id]/edit.vue?macro=true";
import { default as approveYixx1YRvk83yP9tJ5KKo03ovnYYo8h1zruGeDgRU2tcMeta } from "/vercel/path0/stagedoos/pages/organizations/approve.vue?macro=true";
import { default as uitleg0INeZeFMWCLJab0eotF4_7_45CrOP5e5lomiPPs_OP6cgMeta } from "/vercel/path0/stagedoos/pages/stagevoortgang/uitleg.vue?macro=true";
import { default as stagedoos_fieldsFGN609rCnDSYY0FuFduWdOdHsc3fVK2_45ufgJZX_YSpAMeta } from "/vercel/path0/stagedoos/pages/test/stagedoos_fields.vue?macro=true";
import { default as addKQNRC17vDcXqfRl1iKluRTPAkvpxF5VsJ8EKPjuvVWIMeta } from "/vercel/path0/stagedoos/pages/internship_periods/add.vue?macro=true";
import { default as indexjiK5DHhfS8yA3RUgsI_gLUlrFZBrYGRjdOfRicqu6VkMeta } from "/vercel/path0/stagedoos/pages/internships/[id]/index.vue?macro=true";
import { default as editB8Q294B_ag85Cy8wogITiDwjWGpo_45b1YaQ71sOo9ZHQMeta } from "/vercel/path0/stagedoos/pages/organizations/[id]/edit.vue?macro=true";
import { default as indexJ8Mbr2aRcAb9AcnhLuPxDZ0w7_7rc4TTuF1tpG9QEQwMeta } from "/vercel/path0/stagedoos/pages/contract_templates/index.vue?macro=true";
import { default as indext7EkhNabV_RGKRjJLh_45ouBEUqPA5DORqEX91uVpgGDcMeta } from "/vercel/path0/stagedoos/pages/internship_periods/index.vue?macro=true";
import { default as indexcEGHx8bcttBKkOtzyU5ETA9MtcmJmPagBsGtfwdPsFMMeta } from "/vercel/path0/stagedoos/pages/organizations/[id]/index.vue?macro=true";
import { default as index7wcD_mdVtjj_wHsKXihMAzScPJApnFbMplf9DbWEVMwMeta } from "/vercel/path0/stagedoos/pages/organizations/signup/index.vue?macro=true";
import { default as assign_groupPDHOHLr9UY_45_mspr_45__45nqvtKIRou_45RDloLkfS1FhoTIMeta } from "/vercel/path0/stagedoos/pages/students/[id]/assign_group.vue?macro=true";
import { default as editDL9QRRmfiP1ohVdguVnwb_RVqmoeqkF8jUlImpEc7ysMeta } from "/vercel/path0/stagedoos/pages/contract_templates/[id]/edit.vue?macro=true";
import { default as editPjqn7YfxhXSci1OYNtk_VqQW0isYtew3j85fAURr_45B4Meta } from "/vercel/path0/stagedoos/pages/internship_periods/[id]/edit.vue?macro=true";
import { default as indexWKLClckes_45wQO54qEDyHJTIboCDlEbgtVyuojEDWpA8Meta } from "/vercel/path0/base/pages/notification_templates/index.vue?macro=true";
import { default as success4YxtTHUayD_mndnmn_3JfIYbowqsr49iQfpoNmDupLwMeta } from "/vercel/path0/stagedoos/pages/organizations/signup/success.vue?macro=true";
import { default as _91signer_id_9302CmiT2asTmAT99xKx9ZYkwSEXhh1rALUUEw6F1w6SYMeta } from "/vercel/path0/stagedoos/pages/contracts/[id]/sign/[signer_id].vue?macro=true";
import { default as indexDirM38ZeVduO2nhDh_45167ZPRUzv2VJiUMk_45CDyoeGwYMeta } from "/vercel/path0/stagedoos/pages/workflows/[id]/[phase_id]/index.vue?macro=true";
import { default as editzmFIwmFQVKWfhmyEKZUvARa0TDS0fFcKhel6NXGvNZkMeta } from "/vercel/path0/base/pages/notification_templates/[id]/edit.vue?macro=true";
import { default as _91signerId_93teWfB5fzmNApfLyjf7tPKG4xxprT_Srr04SqAU2YRIgMeta } from "/vercel/path0/stagedoos/pages/contracts/[id]/qr-sign/[signerId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexoa3djZDsm3_45SO6f1PjB4SEYTWAZlPq4IWErztVy_45sKoMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/index.vue")
  },
  {
    name: contentGXWpq9tObVjjFJHyj9D9ioI8pM1x9vl6ViUxlnroHdMMeta?.name,
    path: "/content",
    component: () => import("/vercel/path0/base/pages/content.vue"),
    children: [
  {
    name: "content",
    path: "",
    component: () => import("/vercel/path0/base/pages/content/index.vue")
  },
  {
    name: "content-menu-items",
    path: "menu-items",
    component: () => import("/vercel/path0/base/pages/content/menu-items.vue")
  },
  {
    name: "content-file-upload",
    path: "file-upload",
    component: () => import("/vercel/path0/base/pages/content/file-upload.vue")
  },
  {
    name: "content-stock-images",
    path: "stock-images",
    component: () => import("/vercel/path0/base/pages/content/stock-images.vue")
  }
]
  },
  {
    name: "slug",
    path: "/:slug?",
    meta: _91_91slug_93_93lGwrsvU_45b6ap5SRuJL3wvU7noaDbNO5gWJAhjztdrFgMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/[[slug]].vue")
  },
  {
    name: "inloggen",
    path: "/inloggen",
    meta: inloggenEMOsHHmKTy8iFnqZcoiDw4uF0TeVte5OIny1GnHO25UMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/inloggen.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/vercel/path0/stagedoos/pages/dashboard.vue")
  },
  {
    name: "test-auth",
    path: "/test/auth",
    meta: authM6xkMaERq0O0C1h9tZiOQcluo_45wwE4pXcHhyjBKq_iQMeta || {},
    component: () => import("/vercel/path0/base/pages/test/auth.vue")
  },
  {
    name: "test-dupe",
    path: "/test/dupe",
    meta: dupeesfwdPNhguiksYpsbsUNSORkFpYL30oLLcYPc9ZH8uwMeta || {},
    component: () => import("/vercel/path0/base/pages/test/dupe.vue")
  },
  {
    name: "test-form",
    path: "/test/form",
    meta: form2Et0Ex1WDnn1LQOzNPPcUaGcF7_45LiF2eHaPWUbkrjwIMeta || {},
    component: () => import("/vercel/path0/base/pages/test/form.vue")
  },
  {
    name: "test-user",
    path: "/test/user",
    meta: usergP1j2ugkOOTjfIOTEE84Z4_I0BzGtfGwgtoQkc7whosMeta || {},
    component: () => import("/vercel/path0/base/pages/test/user.vue")
  },
  {
    name: "uitloggen",
    path: "/uitloggen",
    component: () => import("/vercel/path0/base/pages/uitloggen.vue")
  },
  {
    name: "users-add",
    path: "/users/add",
    meta: addtCvDip_45gr_RHXHHnVup4604_45OGSrQgt9rSwO0VvjptcMeta || {},
    component: () => import("/vercel/path0/base/pages/users/add.vue")
  },
  {
    name: "auth-reset",
    path: "/auth/reset",
    meta: reset78Ka2XQeSD_Mqmo_45L0NKLVjPtxjgEJykMea_cq2GcswMeta || {},
    component: () => import("/vercel/path0/base/pages/auth/reset.vue")
  },
  {
    name: "auth-token",
    path: "/auth/token",
    component: () => import("/vercel/path0/base/pages/auth/token.vue")
  },
  {
    name: "groups-add",
    path: "/groups/add",
    component: () => import("/vercel/path0/stagedoos/pages/groups/add.vue")
  },
  {
    name: "test-colors",
    path: "/test/colors",
    component: () => import("/vercel/path0/base/pages/test/colors.vue")
  },
  {
    name: "test-sentry",
    path: "/test/sentry",
    component: () => import("/vercel/path0/base/pages/test/sentry.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/vercel/path0/base/pages/users/index.vue")
  },
  {
    name: "auth-login-1",
    path: "/auth/login-1",
    meta: login_451OezAPgOU8OgIsqyIsj0rIcnrmiegfAWEU7y5OhX0Xy4Meta || {},
    component: () => import("/vercel/path0/base/pages/auth/login-1.vue")
  },
  {
    name: "auth-recover",
    path: "/auth/recover",
    meta: recoverKAswSXY0F54QD5SJTFd1JgQTo9zF7PIqylCuE7vRqdoMeta || {},
    component: () => import("/vercel/path0/base/pages/auth/recover.vue")
  },
  {
    name: "groups",
    path: "/groups",
    component: () => import("/vercel/path0/stagedoos/pages/groups/index.vue")
  },
  {
    name: profile_45editfJHqxD9pjopzAWMddQFTUyFlSqGdMh9SStSTdLx5xFsMeta?.name,
    path: "/profile-edit",
    component: () => import("/vercel/path0/base/pages/profile-edit.vue"),
    children: [
  {
    name: "profile-edit-email",
    path: "email",
    component: () => import("/vercel/path0/stagedoos/pages/profile-edit/email.vue")
  },
  {
    name: "profile-edit",
    path: "",
    component: () => import("/vercel/path0/base/pages/profile-edit/index.vue")
  },
  {
    name: "profile-edit-settings",
    path: "settings",
    meta: settings9KYisyRo2PMIyO3Jp18T_45xk0BRll6i8KO0JK1In1g_45sMeta || {},
    component: () => import("/vercel/path0/base/pages/profile-edit/settings.vue")
  },
  {
    name: "profile-edit-periodieke-mail",
    path: "periodieke-mail",
    component: () => import("/vercel/path0/base/pages/profile-edit/periodieke-mail.vue")
  }
]
  },
  {
    name: "test-toaster",
    path: "/test/toaster",
    component: () => import("/vercel/path0/base/pages/test/toaster.vue")
  },
  {
    name: "zelfgevonden",
    path: "/zelfgevonden",
    component: () => import("/vercel/path0/stagedoos/pages/zelfgevonden.vue")
  },
  {
    name: "account-roles",
    path: "/account/roles",
    component: () => import("/vercel/path0/base/pages/account/roles.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    meta: indexJ542y_0elABrCYz1UPobUSRF8cO5KIJnqcqThFfj9YgMeta || {},
    component: () => import("/vercel/path0/base/pages/confirm/index.vue")
  },
  {
    name: "conversations",
    path: "/conversations",
    component: () => import("/vercel/path0/stagedoos/pages/conversations.vue")
  },
  {
    name: "vacancies-add",
    path: "/vacancies/add",
    component: () => import("/vercel/path0/stagedoos/pages/vacancies/add.vue")
  },
  {
    name: "recente_acties",
    path: "/recente_acties",
    component: () => import("/vercel/path0/stagedoos/pages/recente_acties.vue")
  },
  {
    name: "test-step-form",
    path: "/test/step-form",
    component: () => import("/vercel/path0/base/pages/test/step-form.vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    meta: index4G1ApQYCnbWmPdCqsKuhBxNOGqXd9GCpl1HjPahe9ucMeta || {},
    component: () => import("/vercel/path0/base/pages/analytics/index.vue")
  },
  {
    name: "forms-token",
    path: "/forms/:token?",
    meta: _91_91token_93_93G_fI772El8Xn6zqIzr4sJkhuvp_QvgJUfatVtOy9yb4Meta || {},
    component: () => import("/vercel/path0/base/pages/forms/[[token]].vue")
  },
  {
    name: "mentorships-add",
    path: "/mentorships/add",
    component: () => import("/vercel/path0/stagedoos/pages/mentorships/add.vue")
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug?",
    meta: _91_91slug_93_9347z5XE5NpXFKxdK0utfxGJTDXP3zggcWqBpUSy9VcpwMeta || {},
    component: () => import("/vercel/path0/base/pages/nieuws/[[slug]].vue")
  },
  {
    name: "stagebank",
    path: "/stagebank",
    meta: indexkjcz03WsoTUKrJ_DtxXqmcIbpq8gu45xabRmxVOPekcMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/stagebank/index.vue")
  },
  {
    name: "test-datepicker",
    path: "/test/datepicker",
    meta: datepickerZ9Uc62dayGHTsUBHzNt0voknTbZhe3CWBn9nj9du43MMeta || {},
    component: () => import("/vercel/path0/base/pages/test/datepicker.vue")
  },
  {
    name: "test-dollar-api",
    path: "/test/dollar-api",
    component: () => import("/vercel/path0/base/pages/test/dollar-api.vue")
  },
  {
    name: "test-user-store",
    path: "/test/user-store",
    component: () => import("/vercel/path0/base/pages/test/user-store.vue")
  },
  {
    name: "users-id-edit",
    path: "/users/:id()/edit",
    component: () => import("/vercel/path0/base/pages/users/[id]/edit.vue")
  },
  {
    name: "vacancies",
    path: "/vacancies",
    component: () => import("/vercel/path0/stagedoos/pages/vacancies/index.vue")
  },
  {
    name: "workflows",
    path: "/workflows",
    component: () => import("/vercel/path0/stagedoos/pages/workflows/index.vue")
  },
  {
    name: "contactformulier",
    path: "/contactformulier",
    component: () => import("/vercel/path0/base/pages/contactformulier.vue")
  },
  {
    name: "groups-id-edit",
    path: "/groups/:id()/edit",
    component: () => import("/vercel/path0/stagedoos/pages/groups/[id]/edit.vue")
  },
  {
    name: "test-formbuilder",
    path: "/test/formbuilder",
    component: () => import("/vercel/path0/base/pages/test/formbuilder.vue")
  },
  {
    name: "test-step-form-2",
    path: "/test/step-form-2",
    component: () => import("/vercel/path0/base/pages/test/step-form-2.vue")
  },
  {
    name: "urenbriefje-id",
    path: "/urenbriefje/:id()",
    meta: _91id_93SgTGISYKi9TTreLm1yfSZW_osgKfkYDHDTxfDRoWj9UMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/urenbriefje/[id].vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/vercel/path0/base/pages/users/[id]/index.vue")
  },
  {
    name: "analytics-index-2",
    path: "/analytics/index-2",
    component: () => import("/vercel/path0/base/pages/analytics/index-2.vue")
  },
  {
    name: "groups-id",
    path: "/groups/:id()",
    component: () => import("/vercel/path0/stagedoos/pages/groups/[id]/index.vue")
  },
  {
    name: "internships",
    path: "/internships",
    component: () => import("/vercel/path0/stagedoos/pages/internships/index.vue")
  },
  {
    name: "mentorships",
    path: "/mentorships",
    component: () => import("/vercel/path0/stagedoos/pages/mentorships/index.vue")
  },
  {
    name: "organizations-add",
    path: "/organizations/add",
    component: () => import("/vercel/path0/stagedoos/pages/organizations/add.vue")
  },
  {
    name: "privacyverklaring",
    path: "/privacyverklaring",
    meta: privacyverklaringwYxZA0bIjS_45HoZZPYeaENr9k70AVtdd8KqHgWjQclRAMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/privacyverklaring.vue")
  },
  {
    name: "test-server-error",
    path: "/test/server-error",
    component: () => import("/vercel/path0/base/pages/test/server-error.vue")
  },
  {
    name: "instellingen",
    path: "/instellingen",
    component: () => import("/vercel/path0/stagedoos/pages/instellingen/index.vue")
  },
  {
    name: "internships-assign",
    path: "/internships/assign",
    component: () => import("/vercel/path0/stagedoos/pages/internships/assign.vue")
  },
  {
    name: "notificaties",
    path: "/notificaties",
    component: () => import("/vercel/path0/base/pages/notificaties/index.vue")
  },
  {
    name: "students-id-edit",
    path: "/students/:id()/edit",
    component: () => import("/vercel/path0/stagedoos/pages/students/[id]/edit.vue")
  },
  {
    name: "import_groups",
    path: "/import_groups",
    component: () => import("/vercel/path0/stagedoos/pages/import_groups/index.vue")
  },
  {
    name: "organizations",
    path: "/organizations",
    component: () => import("/vercel/path0/stagedoos/pages/organizations/index.vue")
  },
  {
    name: "users-id-add_role",
    path: "/users/:id()/add_role",
    component: () => import("/vercel/path0/base/pages/users/[id]/add_role.vue")
  },
  {
    name: "vacancies-id-edit",
    path: "/vacancies/:id()/edit",
    component: () => import("/vercel/path0/stagedoos/pages/vacancies/[id]/edit.vue")
  },
  {
    name: "contracts-id",
    path: "/contracts/:id()",
    meta: indexWJrRNuIYBjjtp6kLpT_Uspw46ohRDk_45j1e0MKdy3EZYMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/contracts/[id]/index.vue")
  },
  {
    name: "stagevoortgang",
    path: "/stagevoortgang",
    component: () => import("/vercel/path0/stagedoos/pages/stagevoortgang/index.vue")
  },
  {
    name: "vacancies-id",
    path: "/vacancies/:id()",
    meta: indexhAztVC_SaeBkvwaTGsmYw58H9ppaTtzV_Hub_45i9rWcUMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/vacancies/[id]/index.vue")
  },
  {
    name: "workflows-id",
    path: "/workflows/:id()",
    component: () => import("/vercel/path0/stagedoos/pages/workflows/[id]/index.vue")
  },
  {
    name: "internships-id-edit",
    path: "/internships/:id()/edit",
    component: () => import("/vercel/path0/stagedoos/pages/internships/[id]/edit.vue")
  },
  {
    name: "organizations-approve",
    path: "/organizations/approve",
    component: () => import("/vercel/path0/stagedoos/pages/organizations/approve.vue")
  },
  {
    name: "stagevoortgang-uitleg",
    path: "/stagevoortgang/uitleg",
    component: () => import("/vercel/path0/stagedoos/pages/stagevoortgang/uitleg.vue")
  },
  {
    name: "test-stagedoos_fields",
    path: "/test/stagedoos_fields",
    component: () => import("/vercel/path0/stagedoos/pages/test/stagedoos_fields.vue")
  },
  {
    name: "internship_periods-add",
    path: "/internship_periods/add",
    component: () => import("/vercel/path0/stagedoos/pages/internship_periods/add.vue")
  },
  {
    name: "internships-id",
    path: "/internships/:id()",
    component: () => import("/vercel/path0/stagedoos/pages/internships/[id]/index.vue")
  },
  {
    name: "organizations-id-edit",
    path: "/organizations/:id()/edit",
    component: () => import("/vercel/path0/stagedoos/pages/organizations/[id]/edit.vue")
  },
  {
    name: "contract_templates",
    path: "/contract_templates",
    meta: indexJ8Mbr2aRcAb9AcnhLuPxDZ0w7_7rc4TTuF1tpG9QEQwMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/contract_templates/index.vue")
  },
  {
    name: "internship_periods",
    path: "/internship_periods",
    component: () => import("/vercel/path0/stagedoos/pages/internship_periods/index.vue")
  },
  {
    name: "organizations-id",
    path: "/organizations/:id()",
    component: () => import("/vercel/path0/stagedoos/pages/organizations/[id]/index.vue")
  },
  {
    name: "organizations-signup",
    path: "/organizations/signup",
    meta: index7wcD_mdVtjj_wHsKXihMAzScPJApnFbMplf9DbWEVMwMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/organizations/signup/index.vue")
  },
  {
    name: "students-id-assign_group",
    path: "/students/:id()/assign_group",
    component: () => import("/vercel/path0/stagedoos/pages/students/[id]/assign_group.vue")
  },
  {
    name: "contract_templates-id-edit",
    path: "/contract_templates/:id()/edit",
    meta: editDL9QRRmfiP1ohVdguVnwb_RVqmoeqkF8jUlImpEc7ysMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/contract_templates/[id]/edit.vue")
  },
  {
    name: "internship_periods-id-edit",
    path: "/internship_periods/:id()/edit",
    component: () => import("/vercel/path0/stagedoos/pages/internship_periods/[id]/edit.vue")
  },
  {
    name: "notification_templates",
    path: "/notification_templates",
    component: () => import("/vercel/path0/base/pages/notification_templates/index.vue")
  },
  {
    name: "organizations-signup-success",
    path: "/organizations/signup/success",
    meta: success4YxtTHUayD_mndnmn_3JfIYbowqsr49iQfpoNmDupLwMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/organizations/signup/success.vue")
  },
  {
    name: "contracts-id-sign-signer_id",
    path: "/contracts/:id()/sign/:signer_id()",
    meta: _91signer_id_9302CmiT2asTmAT99xKx9ZYkwSEXhh1rALUUEw6F1w6SYMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/contracts/[id]/sign/[signer_id].vue")
  },
  {
    name: "workflows-id-phase_id",
    path: "/workflows/:id()/:phase_id()",
    component: () => import("/vercel/path0/stagedoos/pages/workflows/[id]/[phase_id]/index.vue")
  },
  {
    name: "notification_templates-id-edit",
    path: "/notification_templates/:id()/edit",
    component: () => import("/vercel/path0/base/pages/notification_templates/[id]/edit.vue")
  },
  {
    name: "contracts-id-qr-sign-signerId",
    path: "/contracts/:id()/qr-sign/:signerId()",
    meta: _91signerId_93teWfB5fzmNApfLyjf7tPKG4xxprT_Srr04SqAU2YRIgMeta || {},
    component: () => import("/vercel/path0/stagedoos/pages/contracts/[id]/qr-sign/[signerId].vue")
  }
]